import { Tabs, Tab } from "@mui/material";
import classNames from "classnames";

type TaskTabsProps = {
  tabs: { id: number; label: string }[];
  selectedTab: number;
  setSelectedTab: (tab: number) => void;
};
const TaskTabs = ({ tabs, selectedTab, setSelectedTab }: TaskTabsProps) => {
  return (
    <div className="border-b dark:border-mui-white-12">

      <Tabs
        value={selectedTab}
        onChange={(_, newValue) => setSelectedTab(newValue)}
        TabIndicatorProps={{
          className: "!bg-tgpt-secondary-main",
        }}
      >
        {tabs.map(tab => (
          <Tab
            label={tab.label}
            key={tab.id}
            value={tab.id}
            className={classNames(
              "dark:text-mui-white-70 !normal-case",
              { "!text-tgpt-secondary-main": selectedTab === tab.id },
            )}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default TaskTabs;
